<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CaseACocherLive code="decla1" v-model="sasEquivalence.decla1" :live="liveSasEquivalence(6113)" />
      <CaseACocherLive code="decla2" v-model="sasEquivalence.decla2" :live="liveSasEquivalence(6121)" />
      <CaseACocherLive code="decla3" v-model="sasEquivalence.decla3" :live="liveSasEquivalence(6139)" />
      <CaseACocherLive code="decla4" v-model="sasEquivalence.decla4" :live="liveSasEquivalence(6140)" />
      <CaseACocherLive code="decla5" v-model="sasEquivalence.decla5" :live="liveSasEquivalence(6141)" />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  }
}
</script>

<style>
</style>